<template>
<section>
    <div v-if="report.latePayments != null && report.latePayments.length > 0" class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-xl-3 col-md-3" v-for="(latePayment, loop) in report.latePayments">
                            <div
                                class="card shadow-none bg-transparent"
                                data-toggle="modal"
                                :data-target="'#latePayments_modal_'+loop"
                                :class="reportStore.getAccountDetail(latePayment).payment_status.includes('Late') ? 'border-danger' : 'border-success'"
                            >
                                <div class="card-body">
                                    <h4 class="card-title mb-50 text-primary account-title">
                                        <strong>
                                            {{ reportStore.getAccountDetail(latePayment).furnisher_name }}
                                        </strong>
                                        <span
                                            v-if="reportStore.isNew('latePayments', latePayment)"
                                            class="ml-1 badge badge-pill badge-glow badge-down badge-primary"
                                            style="font-size:10px"
                                        >
                                            New
                                        </span>
                                    </h4>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong>
                                                <i class="fa fa-align-left"></i>
                                                ACCOUNT NUMBER:
                                            </strong>
                                        </span>
                                        {{ reportStore.getAccountDetail(latePayment).account_number }}
                                    </p>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-usd"></i>
                                                ACCOUNT BALANCE: 
                                            </strong>
                                        </span>
                                        {{ reportStore.getAccountDetail(latePayment).balance }}
                                    </p>
                                    <p class="card-text mb-0" >
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-info-circle "></i>
                                                ACCOUNT STATUS: 
                                            </strong>
                                        </span>
                                        <span>
                                            {{ reportStore.getAccountDetail(latePayment).account_status }}
                                        </span>
                                    </p>
                                    <p class="card-text mb-0">
                                        <span class="text-secondary">
                                            <strong style="font-size:12px">
                                                <i class="fa fa-info-circle"></i>
                                                PAYMENT STATUS: 
                                            </strong>
                                        </span>
                                        <span
                                            class="badge badge-pill badge-glow badge-down"
                                            :class="(
                                                reportStore.getAccountDetail(latePayment).payment_status.includes('Late ')
                                                ||
                                                reportStore.getAccountDetail(latePayment).payment_status.includes('Collection')
                                                ||
                                                reportStore.getAccountDetail(latePayment).payment_status.includes('Charge')
                                                ||
                                                reportStore.getAccountDetail(latePayment).payment_status.includes('Derogatory')
                                            ) ? 'badge-danger' : 'badge-primary'"
                                        >
                                            {{ reportStore.getAccountDetail(latePayment).payment_status }}
                                        </span>
                                    </p>
                                    <p class="text-primary float-right mb-0" style="font-size:12px;cursor: pointer;">
                                        <u>View Details</u>
                                    </p>
                                </div>
                            </div>
                            <account-detail-modal :account="latePayment" :email="email" :id="'latePayments_modal_' + loop" account-type="all">
                            </account-detail-modal>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!reportStore.reports[email].haveReport">
        <div class="col-sm-12">
            <div class="card" :class="{ 'shadow': $route.params.client }" >
                <div class="card-body">
                    <div class="mx-auto">
                        <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                        <h6 class=" text-center text-warning mb-2">In order view the Dispute Center, you must import your Credit Report.
                            <br> If you don't already have a credit report, you can get one by clicking the button below.
                        </h6>
                    </div>
                    <div style="text-align:center;">
                        <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                            class="btn btn-warning ">
                            <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p v-else class="text-center font-medium-3 text-bold-600 warning"> You don't have any Report Data.</p>
</section>
</template>

<script>
    import { reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    export default {
        mounted() {
        },
        props: {
            email: String
        },
        created() {
        },
        setup(props) {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                report: useReportStore().reports[props.email].report
            }
        },
        computed: {
        },
        methods: {
        },
    }
</script>
